import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CapitalizeService {
  /**
   * Capitalizes the first letter of a string
   * @param string The string to capitalize
   * @returns The capitalized string
   */
  static capitalize(string: string): string {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
